// extracted by mini-css-extract-plugin
var _1 = "container--oHc0N";
var _2 = "loading--Y9ex5";
export { _1 as "container", _2 as "loading" }
